<template>
  <el-dialog
      :visible.sync="dialogVisible"
      title="编辑"
      top="5vh"
      width="800px">
    <el-form 
        ref="form"
        :model="formData"
        :inline="true"
        label-width="85px">
      <div class="vm-separate">
        <el-form-item label="物料名称">
          <span>{{formData.materialName}}</span>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="铜价">
          <span>{{formData.cuPriceDisplayValue}}</span>
        </el-form-item>
        <el-form-item label="参数1">
          <el-input v-model="formData.param1"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="特性">
          <span>{{formData.propertyName}}</span>
        </el-form-item>
        <el-form-item label="特性值">
          <span>{{formData.displayValue}}</span>
        </el-form-item>
      </div>  
      <div class="vm-separate">
        <el-form-item label="标准价格">
          <el-input v-model="formData.standardPrice" @change="standardPriceInput"/>
        </el-form-item>
        <el-form-item label="成本价格">
          <el-input v-model="formData.costPrice"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="谊新结算价">
          <el-input v-model="formData.yiXinSettlementPrice"/>
        </el-form-item>
        <el-form-item label="销售员价格">
          <el-input v-model="formData.level1Price"/>
        </el-form-item>
      </div>
      <div class="vm-separate">
        <el-form-item label="区总价格">
          <el-input v-model="formData.level2Price"/>
        </el-form-item>
        <el-form-item label="总监价格">
          <el-input v-model="formData.level3Price"/>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer">
      <el-button @click="closePage">取消</el-button>
      <el-button type="primary" @click="handleSubmit">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    data() {
      return {
        dialogVisible:false,
        pkid:0,
        formData:{

        },
      };
    },
    methods:{
      open(row) {
        this.dialogVisible = true;
        if(row) {
          this.pkid = row.pkid;
          this.getData();
        }
      },

      getData() {
        this.$http.get("basic",`CablePrices/${this.pkid}`).then(res=>{
          this.formData = res;
        });
      },

      closePage() {
        this.dialogVisible = false;
      },

      standardPriceInput(value) {
        this.formData.costPrice = (value * 0.93 / 1.17 * 1.13).toFixed(2);
        this.formData.yiXinSettlementPrice = (value * 0.93).toFixed(2);
        this.formData.level1Price = value;
        this.formData.level2Price = value;
        this.formData.level3Price = (value * 0.98).toFixed(2);
      },

      handleSubmit() {
        this.$http.save("basic","CablePrices",this.formData).then(()=>{
          this.$message.success("保存成功");
          this.$emit("save-success");
          this.dialogVisible = false;
        }).catch(()=>{
          this.$message.error("保存失败");
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>